// componenets
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from ".";
export default function Header({ config = {}, visible = true }) {
    const { site_id, company_logo } = config;
    if (!visible) return /*#__PURE__*/ _jsx("div", {});
    return /*#__PURE__*/ _jsxs("div", {
        style: styles.container,
        children: [
            company_logo && /*#__PURE__*/ _jsx("div", {
                style: styles.logoContainer,
                children: /*#__PURE__*/ _jsx("img", {
                    className: "header-logo",
                    src: `${company_logo}`,
                    alt: "Company Logo",
                    style: styles.logo
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                style: styles.header,
                children: site_id && /*#__PURE__*/ _jsxs("div", {
                    style: styles.info,
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "h6",
                            className: "header-company-name",
                            children: "Location:"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            className: "header-company-address",
                            children: site_id
                        })
                    ]
                })
            })
        ]
    });
}
const styles = {
    container: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        height: "100px",
        padding: "20px 0px",
        marginBottom: "20px",
        borderBottom: "1px solid #dcdcdc",
        maxHeight: "64px"
    },
    logoContainer: {
        flexShrink: 0,
        height: "100%",
        display: "flex",
        alignItems: "left"
    },
    logo: {
        height: "100%",
        width: "auto",
        maxWidth: "100%",
        borderRadius: "0%",
        objectFit: "contain"
    },
    header: {
        display: "flex",
        alignItems: "center"
    },
    info: {
        display: "flex",
        flexDirection: "column"
    }
};
